import React from 'react';
import { Link } from 'react-router-dom';
import './ComingSoon.css';

const comingSoonImg = process.env.PUBLIC_URL + '/images/coming-soon/coming-soon.png';

export default function ComingSoon() {
  return (
    <div className="cs-wrapper">

      {/* Inner frame */}
      <div className="cs-frame">
        <span className="cs-corner cs-corner-tr" />
        <span className="cs-corner cs-corner-bl" />

        {/* Tagline */}
        <p className="cs-tagline">
          Etwas Wunderbares ist<br className="cs-break" /> auf dem Weg&hellip;
        </p>

        {/* Brand label */}
        <p className="cs-brand">MANA &middot; Ihre Eventdekoration</p>

        {/* Divider */}
        <div className="cs-divider">
          <span className="cs-line" />
          <span className="cs-ornament">✦</span>
          <span className="cs-line" />
        </div>

        {/* Main image */}
        <div className="cs-image-wrap">
          <img
            src={comingSoonImg}
            alt="Coming Soon"
            className="cs-main-image"
          />
        </div>

        {/* Divider */}
        <div className="cs-divider">
          <span className="cs-line" />
          <span className="cs-ornament">✦</span>
          <span className="cs-line" />
        </div>

        {/* CTA */}
        <Link to="/contact" className="cs-cta">
          Kontakt aufnehmen
        </Link>

      </div>
    </div>
  );
}
